import Container from "../../../../components/container";
import Icon from "../../../../components/icon";
import { EmailTemplate } from "../../../../models";
import { DeleteTemplate, UpdateTemplate } from "./buttons";

export default function TemplatesTable({
  templates,
}: {
  templates: EmailTemplate[];
}) {
  return (
    <Container className="">
      {/* Mobile layout */}
      <div className="lg:hidden">
        {templates?.map((template) => (
          <div
            key={template.id}
            className="mb-2 w-full rounded-md bg-white p-4"
          >
            <h2>{template.name}</h2>
            <div className="flex items-center justify-between  pb-4 mt-2">
              <div className="flex items-center gap-2">
                <p>Subject:</p>
                <p className="text-sm text-gray-500">{template.subject}</p>
              </div>
             
            </div>
             <div className="flex items-center gap-2">
                <p className="text-sm text-gray-500">{template.description}</p>
              </div>
               <div className="flex items-center justify-between  pb-4 mt-2">
                 {template.id ? (
                  <div className="w-full flex items-center justify-center gap-2">
                    <UpdateTemplate id={template.id} />
                    <DeleteTemplate id={template.id} />
                  </div>
                ) : null}
                </div>
          </div>
        ))}
      </div>

      {/* Desktop table */}
      <table className="hidden min-w-full text-gray-900 text-left lg:table ">
        <thead className="rounded-lg text-left text-sm font-normal">
          <tr>
            <th className="px-6 py-3">Name</th>
            <th className="px-6 py-3">Subject</th>
            <th className="px-6 py-3">Description</th>
            <th className="px-6 py-3">Edit</th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {templates.map((template) => (
            <tr key={template.id} className="border-b">
              <td className="whitespace-nowrap px-6 py-3">{template.name}</td>
              <td className="px-6 py-4">{template.subject}</td>
              <td className="px-6 py-4">{template.description}</td>
              <td className="px-6 py-4">
                {template.id ? (
                  <div className="flex items-center justify-start gap-2">
                    <UpdateTemplate id={template.id} />
                    <DeleteTemplate id={template.id} />
                  </div>
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Container>
  );
}
